import Vue from "vue";
import Vuex from "vuex";
import { scan } from "./scan.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    scan,
  },
});
